import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-08/task-01";

const task: Slide = {
  title: "The maximum perception of fluctuation strength and roughness is reached at:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
